import * as v from 'valibot';
/**
 * A date that accepts both the wire form (an ISO **string**) and a real
 * **Date** instance (output-side values read back from Mongo), always yielding
 * a `Date`. Zod's `z.coerce.date()` handled both directions; this restores
 * that. The wrapped `v.date()` renders through `@valibot/to-json-schema` as a
 * string on the snapshot side (see `renderContractSnapshot`), matching the
 * ISO-string reality on the wire.
 */
export const coercedDate = () => v.pipe(v.union([v.string(), v.date()]), v.transform((value) => new Date(value)), 
// Reject malformed strings (`new Date('nope')` yields an Invalid Date),
// restoring what `z.coerce.date()` rejected at the boundary.
v.check((date) => !Number.isNaN(date.getTime()), 'Invalid date'));
export const Weekday = v.union([
    v.literal(0),
    v.literal(1),
    v.literal(2),
    v.literal(3),
    v.literal(4),
    v.literal(5),
    v.literal(6),
]);
export const Time = v.pipe(v.object({
    hour: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(23)),
    minute: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(59)),
}), v.transform((data) => ({
    hour: data.hour,
    minute: data.minute,
})));
//# sourceMappingURL=shared.js.map